import { RouteProps } from "routes";
import Warning from "components/Footer/Warning";
import FooterContent from "components/Footer/FooterContent";
import "./Footer.scss";

function Footer(props: RouteProps) {
  return (
    <div className="footer">
      <Warning />
      <FooterContent {...props} />
    </div>
  );
}

export default Footer;
